import { unitedStates, UnitedStateCode } from "@goodfill/domain-customer-application-types";
import { InputSelect, InputSelectOption } from "@goodfill/ui-components";
import { forwardRef } from "react";
import { Ref } from "react";

const statesOptions: InputSelectOption[] = Object.entries(unitedStates).map(([key, value]) => ({
  value: key,
  label: value,
}));

interface Props {
  onChange: (value: UnitedStateCode | null) => void;
  selected: UnitedStateCode | null;
  isValid: boolean;
  onBlur?: React.FocusEventHandler<HTMLSelectElement>;
  ref?: Ref<HTMLSelectElement>;
  id?: string;
  disabled?: boolean;
}

export const StateInput: React.FC<Props> = forwardRef(
  ({ onChange, selected, isValid, onBlur, id, disabled }, ref) => (
    <InputSelect
      options={statesOptions}
      placeholder="Select state"
      border={isValid ? "neutral" : "red"}
      selected={selected ?? ""}
      onChange={(value) => onChange(value as UnitedStateCode)}
      onBlur={onBlur}
      ref={ref}
      id={id}
      disabled={disabled}
    />
  ),
);
